export { AiDot, type AiDotProps } from './AiDot'
export { default } from './AiDot'
